<template>
  <footer class="w-full h-16 flex items-center justify-center z-50 bg-white border-t border-grey-light">
    &copy; Copyright by Pathao Ltd.
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      copyright: 'Copyright by Pathao Ltd.',
    };
  },
};
</script>
